import { useRef, useState } from "react";
import { ImagePlus, RefreshCw } from "lucide-react";
import { useLang } from "@/context/LangContext";

export const IdUploader = ({ file, onChange }) => {
  const { t } = useLang();
  const ref = useRef(null);
  const [drag, setDrag] = useState(false);
  const preview = file ? URL.createObjectURL(file) : null;

  const pick = (f) => f && f.type.startsWith("image/") && onChange(f);

  return (
    <div
      onClick={() => ref.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => { e.preventDefault(); setDrag(false); pick(e.dataTransfer.files?.[0]); }}
      data-testid="register-id-dropzone"
      className={`relative flex min-h-[180px] cursor-pointer items-center justify-center overflow-hidden rounded-2xl border-2 border-dashed transition-colors ${drag ? "border-primary bg-primary/5" : "border-border bg-muted/40 hover:border-primary/50"}`}
    >
      <input ref={ref} type="file" accept="image/*" className="hidden" data-testid="register-id-upload-input" onChange={(e) => pick(e.target.files?.[0])} />
      {preview ? (
        <>
          <img src={preview} alt="ID preview" data-testid="register-id-preview" className="max-h-64 w-full object-contain p-2" />
          <span className="absolute bottom-3 right-3 flex items-center gap-1.5 rounded-full bg-background/90 px-3 py-1.5 text-xs font-semibold shadow">
            <RefreshCw className="h-3.5 w-3.5" />{t("id_photo_change")}
          </span>
        </>
      ) : (
        <div className="flex flex-col items-center gap-2 p-6 text-center text-muted-foreground">
          <ImagePlus className="h-8 w-8 text-primary" />
          <span className="text-sm">{t("id_photo_hint")}</span>
        </div>
      )}
    </div>
  );
};
